<template>
  <div>
    <label>{{ $tr('settings.emailTemplates.language') }}</label>

    <multiselect
      v-model="languageInnerModel"
      :options="languages"
      open-direction="bottom"
      label="name"
      track-by="code"
      :placeholder="$tr('vacancy.preferences.settings.selectLanguage')"
      :searchable="true"
      :allow-empty="false"
      :show-labels="false"
      class="big"
    />
  </div>
</template>

<script>
export default {
  name: 'languages-multiselect',

  model: {
    prop: 'language',
    event: 'change'
  },

  props: {
    language: {
      type: Object,
      required: true
    },
    languages: {
      type: Array,
      default: [
        { id: 1, code: 'en', name: 'Английский' },
        { id: 2, code: 'ru', name: 'Русский' }
      ]
    }
  },

  computed: {
    languageInnerModel: {
      get () {
        return this.language
      },

      set (val) {
        if (this.isCooldown) {
          return
        }

        this.$emit('change', val)

        this.isCooldown = true
        this.cooldownTimeout = setTimeout(() => {
          this.isCooldown = false
        }, 50)
      }
    }
  },

  beforeMount () {
    this.$store.dispatch('dictionary/countries/fetch')
  },

  beforeDestroy () {
    clearTimeout(this.cooldownTimeout)
  },

  data () {
    return {
      isCooldown: null,
      cooldownTimeout: null
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/styles/colors.scss";

  label {
    font-size: 16px;
    display: block;
    margin-bottom: 10px;
  }

  .row-block { display: flex; }

  label.helper {
    display: block;
    margin: 0;
    color: #a6a6a6;
    line-height: 20px;
    font-size: 14px;
    color: $error-color;
    padding-top: 5px;
  }
</style>
